import { TContentfulImage } from '@/types/contentful';

export type THeadProps = {
  id?: string;
  title?: string;
  slug?: string;
  description?: string;
  image?: TContentfulImage;
  keywords?: string;
};
export const ComponentsHead = ({
  title,
  description,
  image,
  keywords,
}: THeadProps) => {
  return (
    <>
      <meta charSet="utf-8" />
      {title && <title>{title}</title>}
      {description && (
        <meta
          name="description"
          property="og:description"
          content={description}
        />
      )}
      <meta property="og:title" content={title} />
      {image && (
        <meta property="og:image" content={image.url} />
      )}
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:title" content={title} />
      {description && (
        <meta
          name="twitter:description"
          content={description}
        />
      )}
      {image && (
        <meta name="twitter:image" content={image.url} />
      )}
      {keywords && (
        <meta name="keywords" content={keywords} />
      )}
      <meta name="robots" content="all" />
    </>
  );
};
